import { render, staticRenderFns } from "./otherSettingForm.vue?vue&type=template&id=d23ba22a&scoped=true&"
import script from "./otherSettingForm.vue?vue&type=script&lang=js&"
export * from "./otherSettingForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d23ba22a",
  null
  
)

export default component.exports